import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import EChallaneTrafficRules from "./component";

const mapStateToProps = () => ({
    eChallan: { cmsContent: { trafficRules = {} } }
}) => ({
    trafficRules
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EChallaneTrafficRules);
